<template>
  <div class="head-page">
    <Header :title="$t('register.register')" :isreturn="true" />
    <van-tabs v-model="frm.type" @change="tabChange">
      <van-tab :title="$t('register.email')" name="2" v-if="safeWapConfig.email_register_switch == 1"></van-tab>
      <van-tab :title="$t('register.phone')" name="1" v-if="safeWapConfig.phone_register_switch == 1"></van-tab>
    </van-tabs>
    <van-form
      ref="frm"
      validate-first
      @submit="onSubmit"
      @failed="onFailed"
      style="margin-top: 5px"
    >
      <van-field
        v-model="tmp"
        name="validatortmp"
        :placeholder="
          frm.type == 2
            ? $t('register.emailplaceholder')
            : $t('register.phoneplaceholder')
        "
        :rules="[
          { required: true },
          {
            validator: validatortmp,
            message:
              frm.type == 2
                ? $t('register.emailplaceholder')
                : $t('register.phoneplaceholder'),
          },
        ]"
      />
      <van-field
        v-if="frm.type == 2  && safeWapConfig.verify_email_code == 1"
        v-model="frm.captcha"
        center
        clearable
        :placeholder="$t('bank.verify_code')"
        :rules="[{ required: true }]"
      >
        <template #button>
          <span v-if="num == 0" class="link-btn" @click="sendCode">{{
            $t("bank.sendcode")
          }}</span>
          <span v-else>{{ $t("bank.sended", { num, num }) }}</span>
        </template>
      </van-field>
      <van-field
        v-model="frm.password"
        type="password"
        :placeholder="$t('register.pwdplaceholder')"
        :rules="[
          { required: true },
          { validator: validatorpwd, message: $t('register.pwdplaceholder1') },
        ]"
      />
      <van-field
        v-model="frm.repassword"
        type="password"
        name="validator"
        :placeholder="$t('register.agepwdplaceholder')"
        :rules="[
          { required: true },
          { validator: validator, message: $t('register.agepwdplaceholder1') },
        ]"
      />
      <van-field
        v-model="frm.code"
        :placeholder="$t('register.invitecodeplaceholder')"
        :rules="[]"
        v-if="safeWapConfig.invie_code_switch == 1"
      />
      <div style="margin: 16px">
        <van-button native-type="submit" class="web-btn"
          ><van-loading v-if="posting" /><span v-else>{{
            $t("register.register")
          }}</span></van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import Header from "@/components/Header";
import { setToken, getToken } from "@/utils/cookies";
export default {
  name: "RegisterView",
  inject: ["app"],
  computed: {
    safeWapConfig() {
      return this.app.wapConfig || {};
    },
  },
  components: { Header },
  data() {
    return {
      tmp: null,
      num: 0,
      timer: null,
      frm: {
        email: null,
        phone: null,
        password: null,
        repassword: null,
        code: null,
        type: 2,
        captcha: null
      },
      posting: false,
    };
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    validatorpwd(val) {
      return /^[A-Za-z0-9]{6,20}$/.test(val);
    },
    validatortmp(val) {
      let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (this.frm.type != 2) {
        regex = /^\d{6,20}$/;
      }
      return regex.test(val);
    },
    async onSubmit() {
      if (this.posting) {
        return;
      }
      this.posting = true;
      if (this.frm.type == 2) this.frm.email = this.tmp;
      else this.frm.phone = this.tmp;
      await this.$http({
        method: "post",
        url: "register",
        data: this.frm,
      })
        .then((res) => {
          this.posting = false;
          setToken(res.data.userinfo.token);
          location.reload();
        })
        .catch(() => {
          this.posting = false;
        });
    },
    tabChange() {
      this.phone = null;
      this.email = null;
      this.$refs.frm.resetValidation();
    },
    validator(val) {
      return this.frm.password == val;
    },
    onFailed(errorInfo) {
      console.log(errorInfo);
    },
    async sendCode() {
      await this.$http({
        method: "post",
        url: "emssend",
        data: {email: this.tmp}
      }).then(() => {
        this.num = 60;
        const that = this;
        this.$nextTick(() => {
          that.timer = setInterval(() => {
            if (that.num >= 0) that.num -= 1;
            else {
              that.num = 0;
              if (that.timer) clearInterval(that.timer);
            }
          }, 1000);
        });
      });
    },
  },
  mounted() {
    this.frm.type = this.safeWapConfig.email_register_switch == 1 ? 2 : 1
    if (getToken()) {
      this.$router.push({ name: "home" });
    }
    this.frm.code = this.$route.query.invite;
  },
};
</script>

<style>
</style>
